import { render, staticRenderFns } from "./ChatOpenPopup.vue?vue&type=template&id=1955a8b1&scoped=true&"
import script from "./ChatOpenPopup.vue?vue&type=script&lang=js&"
export * from "./ChatOpenPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChatOpenPopup.vue?vue&type=style&index=0&id=1955a8b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1955a8b1",
  null
  
)

export default component.exports